// AI Task Listener Mixin
// Provides automatic draining of queued AI task events when a Stimulus controller connects
// Usage: export default class extends AiTaskListener(Controller) { ... }

export default (Base) => class extends Base {
  connect() {
    super.connect?.()
    this.drainQueuedAiTaskEvents()
  }

  drainQueuedAiTaskEvents() {
    if (!global.state?.aiTaskEvents) {
      return
    }

    // Process all queued events for this controller and forward them to specific handlers
    const queuedEvents = [...global.state.aiTaskEvents]

    queuedEvents.forEach((detail) => {
      if (detail.event === "ai_task_progressed" && this.handleAiTaskProgressed) {
        this.handleAiTaskProgressed({ detail })
      } else if (detail.event === "ai_task_completed" && this.handleAiTaskCompleted) {
        this.handleAiTaskCompleted({ detail })
      }
    })
  }

  removeQueuedAiTaskEventsByType(taskType, taskId = null, eventType = null) {
    // Remove all matching events from the queue to prevent duplicate processing
    if (global.state?.aiTaskEvents) {
      global.state.aiTaskEvents = global.state.aiTaskEvents.filter(
        queuedEvent => {
          // Keep events that don't match the task type
          if (queuedEvent.taskType !== taskType) return true

          // Keep events that don't match the event type when specified
          if (eventType && queuedEvent.event !== eventType) return true

          // If taskId provided, only remove events with matching taskId (or no taskId for backward compatibility)
          if (taskId && queuedEvent.taskId && queuedEvent.taskId !== taskId) return true

          // Remove this event
          return false
        }
      )
    }
  }
}
